import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import Button from 'chameleon/ui-stack/ui/base/button';

import './Annotation.scss';

class Annotation extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    annotationData: PropTypes.shape({
      annotationRequests: PropTypes.object.isRequired,
      variables: PropTypes.object.isRequired,
    }).isRequired,
    highlight: PropTypes.shape({
      id: PropTypes.string.isRequired,
      item: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      offset: PropTypes.number.isRequired,
      selection: PropTypes.string.isRequired,
    }).isRequired,
    isImpersonating: PropTypes.bool,
  };

  static defaultPros = {
    isImpersonating: false,
  };
  constructor(props) {
    super(props);

    const { highlight, annotation, id: learnosityAnnotationId } = props;

    this.state = {
      learnosityAnnotationId,
      highlight,
      annotation,
    };
  }

  updateText = ({ target: { value: annotation } }) => {
    this.setState({ annotation });
  };

  render() {
    const {
      onClose,
      annotationData: {
        annotationRequests: { modal: Composed },
        variables: assignment,
      },
      isImpersonating,
    } = this.props;
    const { highlight, annotation, learnosityAnnotationId } = this.state;
    const variables = {
      learnosityAnnotationId,
      annotation,
      highlight,
      ...assignment,
    };
    return (
      <Composed
        onCompleted={onClose}
        variables={variables}
        isImpersonating={isImpersonating}
      >
        {({
          createAnnotationRequest: { loading: createLoading, createAnnotation },
          updateAnnotationRequest: { loading: updateLoading, updateAnnotation },
          deleteAnnotationRequest: { loading: deleteLoading, deleteAnnotation },
        }) => {
          const loading = createLoading || updateLoading || deleteLoading;
          const saveAnnotation = learnosityAnnotationId
            ? updateAnnotation
            : createAnnotation;
          const btnLabel = learnosityAnnotationId ? 'Edit' : 'Add';
          return (
            <ConfirmDialog
              title="Annotation"
              size="big"
              wrapperClassName="AnnotationModal--dialog"
              onClose={onClose}
              onSuccess={saveAnnotation}
              content={{
                btnPrimary: `${btnLabel} Note`,
                btnSecondary: 'Cancel',
                bottomLeftContent: (
                  <Button
                    isSecondary
                    onClick={deleteAnnotation}
                    disabled={!learnosityAnnotationId}
                    className="mr-auto"
                  >
                    Delete Note
                  </Button>
                ),
              }}
            >
              <form className="Annotation--body pt-8.4 px-12.2 pb-4.2">
                <div>
                  <span className="Annotation--body--title"> Highlight </span>
                  <span className="Annotation--body--quote">
                    {' '}
                    {highlight.selection}{' '}
                  </span>
                </div>
                <div>
                  <label className="Annotation--body--title">
                    Sticky Note
                    <textarea
                      className="Annotation--body--input"
                      value={annotation}
                      onChange={this.updateText}
                    />
                  </label>
                </div>
              </form>
              {loading && <div className="Annotation--overlay" />}
            </ConfirmDialog>
          );
        }}
      </Composed>
    );
  }
}

export default Annotation;
